import { useSelector } from 'react-redux';
import {
  matchPath,
  PathPattern,
  useLocation,
  useSearchParams,
} from 'react-router-dom';

import { Breadcrumb, Icon, Link, Text } from '@poliedro/tamentai';

import { RouteConfig, routesConfig } from '../../routes/routesConfig';
import { RootState } from '../../store';

const matchRoute = (pathname: string): RouteConfig | undefined => {
  let route = routesConfig.find(r => !r.path.includes(':') && r.path === pathname);
  if (route) return route;

  route = routesConfig.find(r => {
    const pattern: PathPattern = { path: r.path, end: true };
    return !!matchPath(pattern, pathname);
  });
  return route;
};

const buildCrumbs = (pathname: string): RouteConfig[] => {
  const list: RouteConfig[] = [];
  let current = matchRoute(pathname);

  while (current) {
    list.unshift(current);
    if (!current.parent) break;
    current = routesConfig.find(r => r.path === current!.parent);
  }
  return list;
};

const crumbLabel = (crumb: RouteConfig, fallbackPath: string): string => {
  if (crumb.path === '/') {
    return crumb.name || 'Cosmos';
  }
  return crumb.name ?? fallbackPath;
};

const BreadCrumb = () => {
  const { pathname } = useLocation();
  const crumbs = buildCrumbs(pathname);
  const [searchParams] = useSearchParams();
  const createdAt = useSelector((state: RootState) => state.chat.createdAt);

  const formattedDate = createdAt
    ? new Date(createdAt).toLocaleDateString('pt-BR')
    : '';

  if (pathname === '/') {
    return <Breadcrumb.Root />;
  }

  return (
    <Breadcrumb.Root>
      {crumbs.map((crumb, index) => {
        let label = crumbLabel(crumb, crumb.path);

        const isLast = index === crumbs.length - 1;
        const section = searchParams.get('n');
        const isForm = searchParams.get('form');

        if (crumb.path === '/chat' && section) {
          switch (section) {
            case 'planejar':
              label = 'Planejar';
              break;
            case 'analisar':
              label = 'Analisar';
              break;
            case 'avaliar':
              label = 'Avaliar';
              break;
          }
        }

        if (crumb.path === '/chat') {
          if (isForm === 'avaliacao') {
            label = 'Criar Avaliação';
          } else if (isForm === 'plano-de-aula') {
            label = 'Criar Plano de Aula';
          }
        }

        if (isLast && crumb.path.includes('/chat/:')) {
          label = formattedDate ? `Conversa do dia ${formattedDate}` : 'Conversa';
        }
        return (
          <Breadcrumb.Item key={index}>
            {isLast ? (
              <>
                <Text variant="body">{label}</Text>
              </>
            ) : (
              <>
                <Link href={crumb.path}>{label}</Link>
                <Icon name="ChevronRight" size="sm" />
              </>
            )}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb.Root>
  );
};

export default BreadCrumb;
